module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTI4IiBoZWlnaHQ9IjEyOCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTE1LjYyNSAxMjcuOTM3SC4wNjNWMTIuMzc1aDU3Ljc4MXYxMi4zNzRIMTIuNDM4djkwLjgxM2g5MC44MTNWNzAuMTU2aDEyLjM3NHoiLz48cGF0aCBkPSJNMTE2LjQyNiAyLjgyMWw4Ljc1MyA4Ljc1My01Ni43MzQgNTYuNzM0LTguNzUzLTguNzQ1eiIvPjxwYXRoIGQ9Ik0xMjcuODkzIDM3Ljk4MmgtMTIuMzc1VjEyLjM3NUg4OC43MDZWMGgzOS4xODd6Ii8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/link.svg
// module id = 1739
// module chunks = 1